<template>
  <div>
    <b-row>
      <!--WEB SERVICE-->
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="host" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.host')" :placeholderValue="$t('common.routing.host')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="port" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="uri" :disabled="readonly" :isMandatory="tb == '1'" :maxLength="512"
          :inputLabel="$t('common.routing.uri')" :placeholderValue="$t('common.routing.uri')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <form-write-group-label-input v-model="timeout" :disabled="readonly" :maxLength="512"
          :inputLabel="$t('common.routing.timeout')" :placeholderValue="$t('common.routing.timeout')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <form-write-group-label-input v-model="connectTimeout" :disabled="readonly" :maxLength="512"
          :inputLabel="$t('common.routing.connect_timeout')" :placeholderValue="$t('common.routing.connect_timeout')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="formatName != '' && formatOutName != ''  && tb != '1'">
        <form-write-group-label-input v-model="formatName" disabled
          :inputLabel="$t('common.routing.format_name')" :placeholderValue="$t('common.routing.format_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="formatName != '' && formatOutName != ''  && tb != '1'">
        <form-write-group-label-input v-model="formatOutName" disabled
          :inputLabel="$t('common.routing.format_out_name')" :placeholderValue="$t('common.routing.format_out_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <label for="ssl-active">
          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="sslActive" :disabled="readonly" id="ssl-active">
          <option value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0" selected> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
      <b-col v-if="sslActive != '0'  && tb != '1'" sm="6" class="form-group">
        <label for="keystore">
          {{ $t('common.routing.keystore') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="keystore" :disabled="readonly" id="keystore">
          <option v-for="keystore in keystoreList" :key="keystore.id" :value="keystore.id"> {{ keystore.name }} </option>
        </select>
      </b-col>
      <b-col sm="6" v-if="sslActive != '0'  && tb != '1'" class="form-group">
        <label for="ca">
          {{ $t('common.routing.certificat') }}
<!--          <span class="color-red"> * </span>-->
        </label>
        <select class="form-control" v-model="ca" :disabled="readonly" id="ca">
          <option v-for="ca in caList" :key="ca.id" :value="ca.id"> {{ ca.name }} </option>
        </select>
      </b-col>
      <b-col sm="6" v-if="tb == '1'"></b-col>

      <b-col sm="6" v-if="tb == '1'" class="form-group mt-3">
        <span>
          <span class="filter-item-title">{{ $t('certificates.details_certificate') }}</span>
          <span class="color-red">* </span>
        </span>
        <br>
        <b-col  sm="12" class="form-group mt-3" v-if="CertificateInput">

          <b-row>
            <b-col>
              <form-read-group-label-input
                  v-if="CertificateInput.deliveredTo !== ''"
                  :inputLabel="$t('certificates.common_name')"
                  :inputValue="CertificateInput.deliveredTo">
              </form-read-group-label-input>
            </b-col>
            <b-col>
              <form-read-group-label-input
                  v-if="CertificateInput.deliveredBy !== ''"
                  :inputLabel="$t('certificates.issued_by')"
                  :inputValue="CertificateInput.deliveredBy">
              </form-read-group-label-input>
            </b-col>
            <b-col>
              <form-read-group-label-input
                  v-if="CertificateInput.startDate !== ''"
                  :inputLabel="$t('certificates.valid_from')"
                  :inputValue="CertificateInput.startDate">
              </form-read-group-label-input>
            </b-col>
            <b-col>
              <form-read-group-label-input
                  v-if="CertificateInput.endDate !== ''"
                  :inputLabel="$t('certificates.valid_until')"
                  :inputValue="CertificateInput.endDate">
              </form-read-group-label-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12" class="mb-2">
              <details class="mt-4">
                <summary class="w-50 btn btn-primary d-inline-block px-3 py-2 rounded">{{ $t('certificates.view_certificate') }}</summary>
                <pre class="p-2 bg-light text-monospace">{{ CertificateInput.certificate }}</pre>
              </details>
            </b-col>
          </b-row>

        </b-col>

      </b-col>

      <b-col sm="6" v-if="tb == '1'" class="form-group d-flex flex-column mt-3">
<!--        <span>-->
<!--          <span class="filter-item-title">{{ $t('certificates.details_certificate_server') }}</span>-->
<!--          <span class="color-red">* </span>-->
<!--        </span>-->
<!--        <br>-->

        <!-- Détails du Certificat Serveur -->
<!--        <div v-if="CertificatServerParsed" class="certificate-details">-->
<!--          <b-col  sm="12" v-if="CertificatServerParsed" class="certificate-details pl-0">-->
<!--            <b-row class="ml-0">-->
<!--              <b-col class="pl-0">-->
<!--                <form-read-group-label-input-->
<!--                    v-if="CertificatServerParsed.deliveredTo !== ''"-->
<!--                    :inputLabel="$t('certificates.common_name')"-->
<!--                    :inputValue="CertificatServerParsed.deliveredTo">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col>-->
<!--                <form-read-group-label-input-->
<!--                    v-if="CertificatServerParsed.deliveredBy !== ''"-->
<!--                    :inputLabel="$t('certificates.issued_by')"-->
<!--                    :inputValue="CertificatServerParsed.deliveredBy">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col>-->
<!--                <form-read-group-label-input-->
<!--                    v-if="CertificatServerParsed.startDate !== ''"-->
<!--                    :inputLabel="$t('certificates.valid_from')"-->
<!--                    :inputValue="CertificatServerParsed.startDate">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col>-->
<!--                <form-read-group-label-input-->
<!--                    v-if="CertificatServerParsed.endDate !== ''"-->
<!--                    :inputLabel="$t('certificates.valid_until')"-->
<!--                    :inputValue="CertificatServerParsed.endDate">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->





<!--          <b-col sm="12" class="p-0" v-if="CertificatServerParsed">-->
<!--            &lt;!&ndash; Affichage du certificat serveur en PEM &ndash;&gt;-->
<!--            <details class="mt-4">-->
<!--              <summary class="w-50 btn btn-primary d-inline-block px-3 py-2 rounded">{{ $t('certificates.view_certificate') }}</summary>-->
<!--              <pre class="p-2 bg-light text-monospace">{{ CertificatServerParsed.certificate }}</pre>-->
<!--            </details>-->
<!--          </b-col>-->
<!--        </div>-->

<!--        <br>-->

        <!-- Détails de l'Autorité de Certification -->
        <div v-if="CAServer" class="certificate-details">

          <span>
            <span class="filter-item-title">{{ $t('certificates.details_ca_server') }}</span>
            <span class="color-red">* </span>
          </span>



          <b-col  sm="12" v-if="CertificatServerParsed" class="certificate-details mt-3 pl-0">
            <b-row class="ml-0">
              <b-col class="pl-0">
                <form-read-group-label-input
                    v-if="CertificatServerParsed.deliveredTo !== ''"
                    :inputLabel="$t('certificates.common_name')"
                    :inputValue="CertificatServerParsed.deliveredTo">
                </form-read-group-label-input>
              </b-col>
              <b-col>
                <form-read-group-label-input
                    v-if="CertificatServerParsed.deliveredBy !== ''"
                    :inputLabel="$t('certificates.issued_by')"
                    :inputValue="CertificatServerParsed.deliveredBy">
                </form-read-group-label-input>
              </b-col>
              <b-col>
                <form-read-group-label-input
                    v-if="CertificatServerParsed.startDate !== ''"
                    :inputLabel="$t('certificates.valid_from')"
                    :inputValue="CertificatServerParsed.startDate">
                </form-read-group-label-input>
              </b-col>
              <b-col>
                <form-read-group-label-input
                    v-if="CertificatServerParsed.endDate !== ''"
                    :inputLabel="$t('certificates.valid_until')"
                    :inputValue="CertificatServerParsed.endDate">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="p-0" v-if="CAServer">
            <!-- Affichage des certificats CA concaténés -->
            <details class="mt-4">
              <summary class="w-50 btn btn-primary d-inline-block px-3 py-2 rounded">{{ $t('certificates.view_ca_certificates') }}</summary>
              <pre class="p-2 bg-light text-monospace">{{ CAServer }}</pre>
            </details>
          </b-col>
        </div>
      </b-col>

      <b-col sm="6" v-if="tb == '1'" class="form-group">

      </b-col>

      <b-col sm="6" class="my-2"></b-col>
    </b-row>
    <form-accordion :title="$t('common.token_credentials')" :isTitleUpperCase="false" v-if="login && password  && tb != '1'">
      <b-row>
        <b-col cols="6" class="fake-hr-right px-0">
          <b-col class="form-group">
            <form-write-group-label-input v-model="loginStorage" :disabled="true" :maxLength="512" inputType="select"
              :inputLabel="$t('common.routing.loginStorage')">
              <select class="form-control" v-model="loginStorage" :disabled="true">
                <option value="">{{ $t('common.routing.volume_select') }}</option>
                <option value="PEM">{{ 'PEM' }}</option>
                <option value="FILE">{{ 'Volume' }}</option>
                <option value="Vault">{{ 'Vault' }}</option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="loginFile" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.loginFile')" :placeholderValue="$t('common.routing.loginFile')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label for="login-file-type">{{ $t('common.variable') }}</label>
                <b-form-radio-group v-model="loginFileType" :disabled="true" id="login-file-type">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="loginYAML" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.loginYAML')" :placeholderValue="$t('common.routing.loginYAML')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label for="login-yaml-type">{{ $t('common.variable') }}</label>
                <b-form-radio-group v-model="loginYAMLType" :disabled="true" id="login-yaml-type">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>

        </b-col>
        <b-col cols="6" class="px-0">
          <b-col class="form-group">
            <form-write-group-label-input v-model="passwordStorage" :disabled="true" :maxLength="512" inputType="select"
              :inputLabel="$t('common.routing.passwordStorage')">
              <select class="form-control" v-model="loginStorage" :disabled="true">
                <option value="">{{ $t('common.routing.volume_select') }}...</option>
                <option value="PEM">{{ 'PEM' }}</option>
                <option value="FILE">{{ 'Volume' }}</option>
                <option value="Vault">{{ 'Vault' }}</option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="passwordFile" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.passwordFile')" :placeholderValue="$t('common.routing.passwordFile')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label for="pwd-file-type">{{ $t('common.variable') }}</label>
                <b-form-radio-group v-model="passwordFileType" :disabled="true" id="pwd-file-type">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="passwordYAML" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.passwordYAML')" :placeholderValue="$t('common.routing.passwordYAML')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label for="pwd-yaml-type">{{ $t('common.variable') }}</label>
                <b-form-radio-group v-model="passwordYAMLType" :disabled="true" id="pwd-yaml-type">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </form-accordion>
    <level-control-form v-if="sslActive === '1'  && tb != '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementWebService"></level-control-form>

    <form-accordion :title="$t('common.proxy')" v-if="tb != '1'" :isTitleUpperCase="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="proxy-active">
            {{ $t('common.routing.proxy_active') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="proxyActive" :disabled="readonly" id="proxy-active">
            <option value="1"> {{ $t('common.routing.yes') }} </option>
            <option value="0" selected> {{ $t('common.routing.no') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group"></b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyHost" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_host')" :placeholderValue="$t('common.routing.proxy_host')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyPort" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_port')" :placeholderValue="$t('common.routing.proxy_port')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyLogin" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_login')" :placeholderValue="$t('common.routing.proxy_login')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyPwd" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_pwd')" :placeholderValue="$t('common.routing.proxy_pwd')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <label for="proxy-tunnel">{{ $t('common.routing.proxy_tunnel') }}</label>
          <b-form-checkbox id="proxy-tunnel"
            :disabled="readonly"
            :value="1"
            :unchecked-value="0"
            v-model="proxyTunnel">
          </b-form-checkbox>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <label for="proxy-connect-only">{{ $t('common.routing.proxy_connect_only') }}</label>
          <b-form-checkbox id="proxy-connect-only"
            :value="1"
            :unchecked-value="0"
            :disabled="readonly"
            v-model="proxyConnectOnly">
          </b-form-checkbox>
        </b-col>
      </b-row>
    </form-accordion>
    <form-accordion :title="$t('common.vop_provider.vop_provider')" :isTitleUpperCase="false" v-if="entitiesType === 'rvm' && tb != '1'">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="vopProvider">
            {{ $t('common.vop_provider.name') }}
          </label>
          <select class="form-control" v-model="IdVopProvider" :disabled="readonly"  id="vopProvider">
            <option value="" hidden disabled> {{ $t('common.routing.select_name_vop_provider') }} </option>
            <option v-for="vopProvider in vopProviderList" :key="vopProvider.id" :value="vopProvider.id">
              {{ vopProvider.text }}
            </option>
          </select>
        </b-col>
      </b-row>
    </form-accordion>
    <!--<certificate-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="certificateConfig" :placementCertificate="placementWebService"></certificate-form-global>
    <private-keys-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="privateKeysConfig" :placementPrivateKey="placementWebService"></private-keys-form-global>-->
  </div>
</template>
<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import {errorMessageAlert} from '@/helpers/alert'
import forge from 'node-forge'
import CertificatePopUp from "@/popups/security/CertificatePopUp.vue"
import {loadPage} from "@/helpers/routing"
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";

export default {
  name: 'WebServiceConfigurationForm',
  components: {
    FormReadGroupLabelInput,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'level-control-form' : LevelControlForm,
    'certificate-pop-up': CertificatePopUp
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    prefilledURI: {
      type: String,
      default: ''
    },
    placementWebService: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    tb: {
      type: String,
      default: "0"
    },
    CertificatServer: {
    },
    CAServer: {
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    formatName: {
      get () {
        return this.inputValue.formatName
      },
      set (val) {
        this.inputValue = {
          formatName: val,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    formatOutName: {
      get () {
        return this.inputValue.formatOutName
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: val,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    name: {
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: val,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    timeout: {
      get () {
        return this.inputValue.timeout
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: val,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    connectTimeout: {
      get () {
        return this.inputValue.connectTimeout
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: val,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    host: {
      get () {
        return this.inputValue.host
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: val,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    port: {
      get () {
        return this.inputValue.port
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: val,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    uri: {
      get () {
        return this.inputValue.uri
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: val,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    sslActive: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.sslActive
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: val,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    controlConfig:{
      get () {
        return this.inputValue.controlConfig
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: val,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    certificateConfig:{
      get () {
        return this.inputValue.certificateConfig
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: val,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    privateKeysConfig:{
      get () {
        return this.inputValue.privateKeysConfig
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: val,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    keystore: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.keystore
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: val,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    ca: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.ca
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: val,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    proxyActive: {
      get () {
        return this.inputValue.proxyActive
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: val,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    proxyHost: {
      get () {
        return this.inputValue.proxyActive === undefined ? '' : this.inputValue.proxyHost
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: val,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    proxyPort: {
      get () {
        return this.inputValue.proxyActive === undefined ? '' : this.inputValue.proxyPort
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: val,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    proxyLogin: {
      get () {
        return this.inputValue.proxyActive === undefined ? '' : this.inputValue.proxyLogin
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: val,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    proxyPwd: {
      get () {
        return this.inputValue.proxyActive === undefined ? '' : this.inputValue.proxyPwd
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: val,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    proxyTunnel: {
      get () {
        return this.inputValue.proxyActive === undefined ? '' : this.inputValue.proxyTunnel
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: val,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    proxyConnectOnly: {
      get () {
        return this.inputValue.proxyActive === undefined ? '' : this.inputValue.proxyConnectOnly
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: val,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    login: {
      get () {
        return this.inputValue.login
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatOutName: this.inputValue.formatOutName,
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: val,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert,
        }
      }
    },
    loginStorage: {
      get () {
        let storageMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    loginFile: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },
    loginFileType: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    loginYAML: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    loginYAMLType: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    password: {
      get () {
        return this.inputValue.password
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: val,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: this.inputValue.IdVopProvider,
          Cert: this.inputValue.Cert
        }
      }
    },
    IdVopProvider: {
      get () {
        return this.inputValue.IdVopProvider === undefined ? '' : this.inputValue.IdVopProvider
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          proxyActive: this.inputValue.proxyActive,
          proxyHost: this.inputValue.proxyHost,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyTunnel: this.inputValue.proxyTunnel,
          proxyConnectOnly: this.inputValue.proxyConnectOnly,
          IdVopProvider: val,
          Cert: this.inputValue.Cert
        }
      },
      Cert: {
        get() {
          return this.inputValue.Cert === undefined ? '' : this.inputValue.Cert
        },
        set(val) {
          this.inputValue = {
            name: this.inputValue.name,
            timeout: this.inputValue.timeout,
            connectTimeout: this.inputValue.connectTimeout,
            host: this.inputValue.host,
            port: this.inputValue.port,
            uri: this.inputValue.uri,
            sslActive: this.inputValue.sslActive,
            controlConfig: this.inputValue.controlConfig,
            certificateConfig: this.inputValue.certificateConfig,
            privateKeysConfig: this.inputValue.privateKeysConfig,
            login: this.inputValue.login,
            password: this.inputValue.password,
            keystore: this.inputValue.keystore,
            ca: this.inputValue.ca,
            proxyActive: this.inputValue.proxyActive,
            proxyHost: this.inputValue.proxyHost,
            proxyPort: this.inputValue.proxyPort,
            proxyLogin: this.inputValue.proxyLogin,
            proxyPwd: this.inputValue.proxyPwd,
            proxyTunnel: this.inputValue.proxyTunnel,
            proxyConnectOnly: this.inputValue.proxyConnectOnly,
            IdVopProvider: this.inputValue.IdVopProvider,
            Cert: val
          }
        }
      }
    },
    passwordStorage: {
      get () {
        let storageMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    passwordFile: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },
    passwordFileType: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    passwordYAML: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    passwordYAMLType: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    }
  },
  data () {
    return {
      keystoreList: [],
      caList: [],
      vopProviderList: [],
      CertificateInput: null,
      CertificatServerParsed: null,
      form: {
        C: "FR",
        O: "ClientBank",
        CN: "client1.bank.fr",
        LEI: "254900VWZ8JBWCEP2D91",
        subjectAltName: "DNS:client1.bank.fr",
        mode: "clientAuth"
      },
      isSubjectAltNameEditable: true,
      showModal: false,
      modeOptions: [
        { value: "clientAuth", text: "Client Auth" },
        { value: "serverAuth", text: "Server Auth" }
      ]
    }
  },
  created () {
    this.entitiesType = ''
    if (this.tb != '1'){
      this.entitiesType = this.$route.params.entitiesType
      if (this.mode === 'create') {
        if (this.prefilledURI !== undefined || this.prefilledURI === '') {
          this.inputValue.uri = this.prefilledURI
        }
        this.inputValue.sslActive = '0'
      }

      this.getCA()
      this.getKeyStore()
      this.getVopProvider()
    }else{
      this.CertificatServerParsed = this.parseCertificate(this.CAServer)
      this.CertificateInput = this.parseCertificate(this.CertificatServer)
    }
  },
  methods: {
    openPopup() {
      this.showModal = true
    },
    closePopup() {
      this.showModal = false
    },
    submitForm() {
      let that = this

      this.$engine.routing.config.webService.generateCertificatQwacLike(this.form)
          .then(resp => {

            if (!resp.data.certificate || !resp.data.key) {
              console.error("❌ Erreur : Certificat ou clé privée manquants !")
              return
            }

            // Décoder le Base64
            const decodedCert = atob(resp.data.certificate)
            const decodedKey = atob(resp.data.key)


            // Téléchargement des fichiers
            that.downloadBase64File(resp.data.certificate, 'certificat.crt', 'application/x-x509-ca-cert')
            that.downloadBase64File(resp.data.key, 'private_key.key', 'application/x-pem-file')
            that.closePopup()


            try {
              const certificate = forge.pki.certificateFromPem(decodedCert)
              const pemFormattedCert = forge.pki.certificateToPem(certificate)

              this.inputValue.CertificateText = pemFormattedCert

              // Formatage des dates (YYYY-MM-DD)
              const startDate = certificate.validity.notBefore.toISOString().split('T')[0]
              const endDate = certificate.validity.notAfter.toISOString().split('T')[0]

              // Fonction pour récupérer les valeurs des attributs
              const getAttributeValue = (attributes, name) => {
                const attr = attributes.find(attr => attr.name === name)
                return attr ? attr.value : 'Inconnu'
              }

              // Récupération des informations
              const deliveredBy = getAttributeValue(certificate.issuer.attributes, 'commonName')
              const deliveredTo = getAttributeValue(certificate.subject.attributes, 'commonName')

              // Création de l'objet CertificateInput
              const CertificateInput = {
                certificate: pemFormattedCert,  // Contenu du certificat en PEM
                startDate,                      // Date de début de validité
                endDate,                        // Date de fin de validité
                deliveredBy,                    // Émetteur du certificat
                deliveredTo,                    // Destinataire (CN)
                nameDisplay: deliveredTo         // Affichage du nom (même que deliveredTo)
              }

              // Mise à jour de la data en fonction de index
              this.CertificateInput = CertificateInput
              this.inputValue.Cert = decodedCert



            } catch (err) {
              console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err)
            }
          })
          .catch(e => {
            errorMessageAlert(e, that)
            that.okMessageBox(that.$t('common.routing.config_addition_error'))
          })
    },
    downloadBase64File(base64Data, filename, mimeType) {
      let linkSource = `data:${mimeType}base64,` + base64Data
      let downloadLink = document.createElement('a')

      // Vérification si mobile
      if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
        downloadFileWithDefinedHeaders(this, filename, linkSource)
      } else {
        downloadLink.href = linkSource
        downloadLink.download = filename
        downloadLink.click()
      }
    },
    getCA () {
      let that = this
      this.$engine.security.ca.fetch()
      .then(resp => {
        let CAList = {}

        CAList = resp.data.ca
        this.caList = CAList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getKeyStore () {
      let that = this
      this.$engine.security.keystore.fetch()
      .then(resp => {
        let privateKeysList = {}

        privateKeysList = resp.data.keystore

        this.keystoreList = privateKeysList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    handleFileUploadCertificat(event, index = null) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const pemContent = e.target.result

        try {
          const certificate = forge.pki.certificateFromPem(pemContent)
          const pemFormattedCert = forge.pki.certificateToPem(certificate)

          this.inputValue.CertificateText = pemFormattedCert

          // Formatage des dates (YYYY-MM-DD)
          const startDate = certificate.validity.notBefore.toISOString().split('T')[0]
          const endDate = certificate.validity.notAfter.toISOString().split('T')[0]

          // Fonction pour récupérer les valeurs des attributs
          const getAttributeValue = (attributes, name) => {
            const attr = attributes.find(attr => attr.name === name)
            return attr ? attr.value : 'Inconnu'
          }

          // Récupération des informations
          const deliveredBy = getAttributeValue(certificate.issuer.attributes, 'commonName')
          const deliveredTo = getAttributeValue(certificate.subject.attributes, 'commonName')

          // Création de l'objet CertificateInput
          const CertificateInput = {
            certificate: pemFormattedCert,  // Contenu du certificat en PEM
            startDate,                      // Date de début de validité
            endDate,                        // Date de fin de validité
            deliveredBy,                    // Émetteur du certificat
            deliveredTo,                    // Destinataire (CN)
            nameDisplay: deliveredTo         // Affichage du nom (même que deliveredTo)
          }

          // Mise à jour de la data en fonction de index
          if (index == null) {
            this.CertificateInput = CertificateInput  // Stockage unique
            this.inputValue.Cert = pemContent
          } else {
            this.inputValue.CertificatList[index] = CertificateInput  // Mise à jour d'une liste
          }


        } catch (err) {
          console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err)
        }
      }


      reader.readAsText(file)
    },
    getVopProvider () {
      let params = {}
      let that = this
      this.$engine.vopProvider.getVopProvider(params).then((resp) => {
        this.vopProviderList = resp.data.VopProvider.map(vopProvider => ({
          id: vopProvider.IdVopProvider,
          text: vopProvider.NameVopProvider,
          value: vopProvider.NameVopProvider
        }))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    parseCertificate (pemCert) {
      try {
        const cert = forge.pki.certificateFromPem(pemCert);
        return {
          certificate: pemCert,  // Contenu du certificat en PEM
          startDate: cert.validity.notBefore.toISOString().split('T')[0],
          endDate: cert.validity.notAfter.toISOString().split('T')[0],
          deliveredBy: this.getAttributeValue(cert.issuer.attributes, 'commonName'),
          deliveredTo: this.getAttributeValue(cert.subject.attributes, 'commonName'),
        };
      } catch (err) {
        console.error("Erreur de parsing du certificat :", err);
        return null;
      }
    },
    getAttributeValue (attributes, name) {
      const attr = attributes.find(attr => attr.name === name);
      return attr ? attr.value : 'Inconnu';
    }
  }
}

</script>
